/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Map_Stories_BtnInputs */

const en_story_bank_map_stories_btn = /** @type {(inputs: Story_Bank_Map_Stories_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map Stories`)
};

const de_story_bank_map_stories_btn = /** @type {(inputs: Story_Bank_Map_Stories_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map Stories`)
};

const fr_story_bank_map_stories_btn = /** @type {(inputs: Story_Bank_Map_Stories_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map Stories`)
};

const es_story_bank_map_stories_btn = /** @type {(inputs: Story_Bank_Map_Stories_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map Stories`)
};

const it_story_bank_map_stories_btn = /** @type {(inputs: Story_Bank_Map_Stories_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map Stories`)
};

const nl_story_bank_map_stories_btn = /** @type {(inputs: Story_Bank_Map_Stories_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map Stories`)
};

const pl_story_bank_map_stories_btn = /** @type {(inputs: Story_Bank_Map_Stories_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map Stories`)
};

const fi_story_bank_map_stories_btn = /** @type {(inputs: Story_Bank_Map_Stories_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map Stories`)
};

const da_story_bank_map_stories_btn = /** @type {(inputs: Story_Bank_Map_Stories_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map Stories`)
};

const sv_story_bank_map_stories_btn = /** @type {(inputs: Story_Bank_Map_Stories_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map Stories`)
};

/**
* | output |
* | --- |
* | "Map Stories" |
*
* @param {Story_Bank_Map_Stories_BtnInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_map_stories_btn = /** @type {((inputs?: Story_Bank_Map_Stories_BtnInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Map_Stories_BtnInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_map_stories_btn(inputs)
	if (locale === "fr") return fr_story_bank_map_stories_btn(inputs)
	if (locale === "es") return es_story_bank_map_stories_btn(inputs)
	if (locale === "it") return it_story_bank_map_stories_btn(inputs)
	if (locale === "nl") return nl_story_bank_map_stories_btn(inputs)
	if (locale === "pl") return pl_story_bank_map_stories_btn(inputs)
	if (locale === "fi") return fi_story_bank_map_stories_btn(inputs)
	if (locale === "da") return da_story_bank_map_stories_btn(inputs)
	if (locale === "sv") return sv_story_bank_map_stories_btn(inputs)
	return en_story_bank_map_stories_btn(inputs)
});